import styled from 'styled-components'

interface IBudgetCategoryListStyledProps {}

export const BudgetCategoryListStyled = styled.div<IBudgetCategoryListStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  table.budget-list {
    tr.budget.budget--overage td.budget--amount {
      color: ${(props) => props.theme.colors.danger};
      font-weight: ${(props) => props.theme.fontWeights.bold};
    }
  }
`
